import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Officials = () => {
    const [officials, setOfficials] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editing, setEditing] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        position: '',
        bio: '',
        is_active: true,
        order: 0,
    });
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);

    useEffect(() => {
        fetchOfficials();
    }, []);

    const fetchOfficials = async () => {
        try {
            const token = localStorage.getItem('admin_token');
            const response = await axios.get('http://localhost:8000/api/admin/officials', {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setOfficials(response.data);
        } catch (error) {
            console.error('Error fetching officials:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formDataToSend = new FormData();
        
        Object.keys(formData).forEach(key => {
            formDataToSend.append(key, formData[key]);
        });
        
        if (imageFile) {
            formDataToSend.append('image', imageFile);
        }

        try {
            const token = localStorage.getItem('admin_token');
            if (editing) {
                await axios.post(`http://localhost:8000/api/admin/officials/${editing.id}?_method=PUT`, formDataToSend, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    }
                });
            } else {
                await axios.post('http://localhost:8000/api/admin/officials', formDataToSend, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    }
                });
            }
            fetchOfficials();
            resetForm();
        } catch (error) {
            console.error('Error saving official:', error);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this official?')) {
            try {
                const token = localStorage.getItem('admin_token');
                await axios.delete(`http://localhost:8000/api/admin/officials/${id}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                fetchOfficials();
            } catch (error) {
                console.error('Error deleting official:', error);
            }
        }
    };

    const handleEdit = (official) => {
        setEditing(official);
        setFormData({
            name: official.name,
            position: official.position,
            bio: official.bio || '',
            is_active: official.is_active,
            order: official.order || 0,
        });
        setImagePreview(official.image_path);
        setShowModal(true);
    };

    const resetForm = () => {
        setFormData({
            name: '',
            position: '',
            bio: '',
            is_active: true,
            order: 0,
        });
        setImageFile(null);
        setImagePreview(null);
        setEditing(null);
        setShowModal(false);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    if (loading) return <div className="admin-loading">Loading officials...</div>;

    return (
        <div>
            <div className="admin-header">
                <h2>Officials Management</h2>
                <button className="admin-add-btn" onClick={() => setShowModal(true)}>
                    + Add New Official
                </button>
            </div>

            {officials.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '3rem', color: '#6b7a8f' }}>
                    <p>No officials found. Click "Add New Official" to create one.</p>
                </div>
            ) : (
                <div className="admin-table-wrapper">
                    <table className="admin-table">
                        <thead>
                            <tr>
                                <th>Image</th>
                                <th>Name</th>
                                <th>Position</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {officials.map((official) => (
                                <tr key={official.id}>
                                    <td>
                                        {official.image_path ? (
                                            <img 
                                                src={`http://localhost:8000${official.image_path}`} 
                                                alt={official.name}
                                                className="admin-image-preview-thumb"
                                                onError={(e) => e.target.style.display = 'none'}
                                            />
                                        ) : (
                                            <span style={{ color: '#9ca3af' }}>No image</span>
                                        )}
                                    </td>
                                    <td><strong>{official.name}</strong></td>
                                    <td>{official.position}</td>
                                    <td>
                                        <span className={`admin-status-badge ${official.is_active ? 'admin-status-active' : 'admin-status-inactive'}`}>
                                            {official.is_active ? 'Active' : 'Inactive'}
                                        </span>
                                    </td>
                                    <td>
                                        <div className="admin-actions">
                                            <button className="admin-edit-btn" onClick={() => handleEdit(official)}>Edit</button>
                                            <button className="admin-delete-btn" onClick={() => handleDelete(official.id)}>Delete</button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {showModal && (
                <div className="admin-modal-overlay" onClick={() => resetForm()}>
                    <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="admin-modal-header">
                            <h2>{editing ? 'Edit Official' : 'Add New Official'}</h2>
                            <button className="admin-modal-close" onClick={resetForm}>×</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="admin-form-group">
                                <label>Name *</label>
                                <input
                                    type="text"
                                    value={formData.name}
                                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                                    required
                                />
                            </div>
                            <div className="admin-form-group">
                                <label>Position *</label>
                                <input
                                    type="text"
                                    value={formData.position}
                                    onChange={(e) => setFormData({...formData, position: e.target.value})}
                                    required
                                />
                            </div>
                            <div className="admin-form-group">
                                <label>Bio</label>
                                <textarea
                                    value={formData.bio}
                                    onChange={(e) => setFormData({...formData, bio: e.target.value})}
                                    rows="3"
                                />
                            </div>
                            <div className="admin-form-group">
                                <label>Order</label>
                                <input
                                    type="number"
                                    value={formData.order}
                                    onChange={(e) => setFormData({...formData, order: parseInt(e.target.value)})}
                                />
                            </div>
                            <div className="admin-form-group">
                                <label>Image</label>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleImageChange}
                                />
                                {imagePreview && (
                                    <div style={{ marginTop: '10px' }}>
                                        <img 
                                            src={imagePreview} 
                                            alt="Preview" 
                                            className="admin-image-preview"
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="admin-form-group">
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={formData.is_active}
                                        onChange={(e) => setFormData({...formData, is_active: e.target.checked})}
                                    />
                                    Active
                                </label>
                            </div>
                            <button type="submit" className="admin-submit-btn">
                                {editing ? 'Update Official' : 'Create Official'}
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Officials;